import { GetOptions, PaypalPayment } from "@/core";
import { ResolvePaypalPaymentMatchPayload } from "@/core/ports/services/functions-service";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const paypalPaymentRepository =
  repositoryHost.getPaypalPaymentRepository(databaseService);
const functionsService = serviceHost.getFunctionsService();

export const usePaypalPayments = (options: GetOptions<PaypalPayment>) => {
  return useInfiniteQuery({
    queryKey: ["paypal-payments", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      paypalPaymentRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};

export const useResolvePaypalPaymentMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ResolvePaypalPaymentMatchPayload) =>
      functionsService.resolvePaypalPaymentMatch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["paypal-payments"] });
      // Matching also creates/removes the context-only Payment on the PO.
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      queryClient.invalidateQueries({ queryKey: ["purchase-orders"] });
    },
  });
};
